import React, { FC } from "react";
import classNames from "classnames";
import {
  BlockHeader,
  HeaderLevel,
} from "@app/components/common/block-header/BlockHeader";
import { BlockBody } from "@app/components/common/block-body/BlockBody";
import { FaqItemContent } from "./types";

type Props = {
  id: string;
  question: FaqItemContent;
  isActive: boolean;
  onSetActive: (id: string) => void;
  isDividerHidden?: boolean;
};

export const FaqItem: FC<Props> = ({
  id,
  question,
  isActive,
  onSetActive,
  isDividerHidden,
}) => (
  <div
    className={classNames(
      "collapse-arrow collapse",
      "group text-regular rounded-none py-1",
      "xl:py-3",
      {
        "collapse-open": isActive,
        "border-divider border-b border-solid": !isDividerHidden,
      },
    )}
  >
    <div
      onClick={() => onSetActive(id)}
      className={classNames(
        "collapse-title !cursor-pointer",
        "text-regular text-primary-content pl-0",
        "xl:text-medium",
      )}
    >
      <BlockHeader
        richText={question.title}
        headerLevel={HeaderLevel.H5}
        className="text-base-400"
      />
    </div>
    <div
      className={classNames(
        "collapse-content",
        "text-base-400 px-0",
        "[&>p]:mb-2.5 [&>p]:last:mb-0 [&>p]:lg:mb-5",
        "group-has-[:checked]:pb-5",
        "xl:group-has-[:checked]:pb-7",
        "[&_ul]:mb-2.5 [&_ul]:pl-6 [&_ul>li]:pl-3",
        "[&_ul]:list-disc [&_ul]:text-start [&_ul]:lg:mb-5",
      )}
    >
      <BlockBody richText={question.text} />
    </div>
  </div>
);
